global.site_name = "Vulture";
